<!-- Notas con TinyMCE -->

<template>
  <div class="border-t border-slate-200 dark:border-slate-700 pt-6 space-y-2">
    <h2 class="text-slate-900 dark:text-slate-100 text-lg font-semibold leading-tight">Notas</h2>
    <editor
      v-model="localNotes"
      :api-key="apiKey"
      :init="editorConfig"
      @update:modelValue="updateNotes"
    />
  </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue';

export default {
  components: {
    Editor
  },
  props: {
    notes: String,
  },
  data() {
    return {
      localNotes: this.notes || "",
      apiKey: process.env.VUE_APP_TINYMCE_API_KEY || 'rg0qmdu719tlzhg0xuj1v8t9ldw6fccjjvnep9iuh9bv0eai',
      isDarkMode: false,
      observer: null
    };
  },
  computed: {
    isDark() {
      return this.isDarkMode;
    },
    editorConfig() {
      return {
        height: 300,
        menubar: false,
        plugins: [
          'advlist', 'autolink', 'lists', 'link', 'charmap', 'preview',
          'searchreplace', 'visualblocks', 'fullscreen',
          'insertdatetime', 'table', 'code', 'help', 'wordcount', 'paste',
          'textcolor', 'colorpicker', 'contextmenu'
        ],
        toolbar:
          'undo redo | formatselect | ' +
          'bold italic underline | forecolor backcolor | alignleft aligncenter ' +
          'alignright alignjustify | bullist numlist outdent indent | ' +
          'table tabledelete | tableprops tablerowprops tablecellprops | ' +
          'tableinsertrowbefore tableinsertrowafter tabledeleterow | ' +
          'tableinsertcolbefore tableinsertcolafter tabledeletecol | ' +
          'removeformat | help',
        // Enhanced paste settings for better table handling
        paste_retain_style_properties: 'border border-color border-width background-color color font-weight text-align',
        paste_word_valid_elements: 'b,strong,i,em,h1,h2,h3,h4,h5,h6,p,ol,ul,li,a[href],span,color,font-size,font-color,font-family,mark,table,tr,td,th,tbody,thead,tfoot',
        paste_webkit_styles: 'border color font-weight text-align background-color',
        paste_merge_formats: true,
        paste_convert_word_fake_lists: true,
        paste_remove_styles_if_webkit: false,
        table_use_colgroups: false,
        table_responsive_width: true,
        table_default_attributes: {
          'border': '1'
        },
        table_default_styles: {
          'border-collapse': 'collapse',
          'width': '100%'
        },
        content_style: this.isDark 
          ? 'body { font-family: -apple-system, BlinkMacSystemFont, \'Segoe UI\', Roboto, Oxygen-Sans, Ubuntu, Cantarell, \'Helvetica Neue\', sans-serif; font-size: 14px; background-color: #334155; color: #f1f5f9; }'
          : 'body { font-family: -apple-system, BlinkMacSystemFont, \'Segoe UI\', Roboto, Oxygen-Sans, Ubuntu, Cantarell, \'Helvetica Neue\', sans-serif; font-size: 14px }',
        placeholder: 'Escribe tus notas aquí...',
        skin: this.isDark ? 'oxide-dark' : 'oxide',
        icons: 'thin'
      };
    }
  },
  watch: {
    notes(newVal) {
      if (newVal !== this.localNotes) {
        this.localNotes = newVal;
      }
    },
  },
  mounted() {
    this.updateDarkModeState();
    this.observer = new MutationObserver(() => {
      this.updateDarkModeState();
    });
    this.observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class']
    });
  },
  beforeUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    updateDarkModeState() {
      this.isDarkMode = document.documentElement.classList.contains('dark');
    },
    updateNotes(value) {
      this.localNotes = value;
      this.$emit("update:notes", value);
    }
  }
};
</script>

